import { useEffect, useState } from "react";
import { ethers } from "ethers";
import { getMarketplaceContract } from "../utils/marketplace";
import NFTCard from "./NFTCard";

function NFTList({ signer }) {
  const [listings, setListings] = useState([]);

  useEffect(() => {
    const fetchListings = async () => {
      const marketplace = getMarketplaceContract(signer);

      const nfts = [];
      for (let i = 1; i <= 10; i++) {
        try {
          const listing = await marketplace.listings("0x35270c78593AB2b6BE570CA02e10EbDBDe0Fd80a", i);
          if (listing.active) {
            nfts.push({
              tokenId: i,
              startPrice: ethers.formatEther(listing.startPrice),
              buyNowPrice: ethers.formatEther(listing.buyNowPrice),
              highestBid: ethers.formatEther(listing.highestBid),
              deadline: Number(listing.deadline),
              nftAddress: listing.nftAddress,
            });
            
          }
        } catch (e) {
          continue; // 없는 tokenId는 무시
        }
      }
      setListings(nfts);
    };

    fetchListings();
  }, [signer]);

  return (
    <div className="component-card">
      <h2 style={{ textAlign: 'center', marginBottom: 16 }}>Listed NFTs</h2>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "20px",
          justifyContent: "center",
          alignItems: "stretch",
          width: "100%"
        }}
      >
        {listings.map((nft) => (
          <NFTCard key={nft.tokenId} {...nft} signer={signer} />
        ))}
      </div>
    </div>
  );
}

export default NFTList;
